import axiosHttp from "./interceptor.service";

const postCategory = (data) => {
  return axiosHttp.post("/feedback/createCategory", data);
};

const getCategory = ({ sort, page, limit, search, departmentRoleId } = {}) => {
  return axiosHttp.get("/feedback/getCategory", {
    params: { sort, page, limit, search, roleId: departmentRoleId },
  });

};

const getRole = (params = {}) => {
  return axiosHttp.get("/feedback/getRole", { params });
};


const updateCategory = (id, data) => {
  return axiosHttp.put(`/feedback/updateCategory/${id}`, data);
};

const deleteCategory = (id) => {
  return axiosHttp.delete(`/feedback/deleteCategory/${id}`);
};

export { postCategory, getCategory, updateCategory, deleteCategory, getRole };
